import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { CalculatorPrefixContext } from '../contexts/CalculatorContext';

export function useSelectedMenu<T extends string>(route: T, params = {disablePrefix: false}): boolean {
    const location = useLocation();
    const calculatorPrefixContext = useContext(CalculatorPrefixContext)!;
    const calculatorPrefix = !params.disablePrefix ? `/${calculatorPrefixContext[0]}` : ''

    return location.pathname === `${calculatorPrefix}/${route}`;
}
